<div class="modal-header">
  <h3 class="modal-title">Selecione uma Área</h3>
</div>

<div class="modal-body no-padding modal-selecao-area" >
  <leaflet-map id="selecao-area-demarcada-map" bounds="$selecao.bounds"></leaflet-map>
</div>

<div class="modal-footer text-right">
  <span
    ng-show="$selecao.selecionada"
    class="font-bold text-primary"
  >
    {{$selecao.selecionada.descricao}} | {{$selecao.selecionada.empreendimento.descricao}}
  </span>
  <button
    ng-disabled="!$selecao.selecionada"
    class="btn btn-primary"
    type="button"
    ng-click="$selecao.confirm($selecao.selecionada)"
  >
    Selecionar
  </button>
</div>
